import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Loading,
  TextField,
} from "../../../../components";
import { notification, ServicoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const servicoService = new ServicoService();

export function CopiarServicoDialog({ open, setOpen, handleCopiarServico }) {
  const [servicos, setServicos] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [servicoSelecionadoId, setServicoSelecionadoId] = useState(null);
  const [busca, setBusca] = useState("");
  const [loading, setLoading] = useState(false);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      width: 120,
    },
    {
      field: "nome",
      headerName: "Nome",
      flex: 1,
      minWidth: 220,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 1,
      minWidth: 250,
      sortable: false,
    },
    {
      field: "precoServico",
      headerName: "Preço do Serviço",
      width: 170,
      sortable: false,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => formatPrice(params.value || 0),
    },
  ];

  const buscarServicos = (filtros = {}) => {
    setLoading(true);
    servicoService
      .getAll({
        ativado: true,
        orderBy: "nome",
        order: "asc",
        ...filtros,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setServicos(result.data.rows);
          setRowCount(result.data.count);
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open) {
      buscarServicos();
    }
  }, [open]);

  const handlePesquisar = (e) => {
    if (e) e.preventDefault();
    setServicoSelecionadoId(null);
    buscarServicos(busca ? { nome: busca } : {});
  };

  const sendServerDatagrid = (props) => {
    buscarServicos({
      ...(busca ? { nome: busca } : {}),
      ...props.filtros,
    });
  };

  const handleClose = () => {
    setBusca("");
    setServicos([]);
    setServicoSelecionadoId(null);
    setOpen(false);
  };

  const confirmarCopia = async () => {
    if (!servicoSelecionadoId) {
      return notification.alertaGenericos("Selecione um serviço para copiar");
    }
    setLoading(true);
    await handleCopiarServico(servicoSelecionadoId);
    setLoading(false);
    handleClose();
  };

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <CardHeader
        title="Copiar Serviço"
        className="m-2"
        action={
          <IconButton color="inherit" onClick={handleClose}>
            <i className="ph-bold ph-x" style={{ fontSize: 20 }}></i>
          </IconButton>
        }
      />
      <DialogContent>
        <Box
          component="form"
          onSubmit={handlePesquisar}
          sx={{ display: "flex", gap: 1, mb: 2 }}
        >
          <TextField
            fullWidth
            label="Pesquisar por nome"
            variant="outlined"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
          <Button type="submit" variant="contained" sx={{ minWidth: 120 }}>
            Buscar
          </Button>
        </Box>
        <DataGrid
          checkboxSelection
          selectionModel={[servicoSelecionadoId]}
          onRowSelectionModelChange={(selectedIds) => {
            const id =
              selectedIds?.length > 1 ? [selectedIds.pop()] : selectedIds;
            setServicoSelecionadoId(id[0] ?? null);
          }}
          paginationMode="server"
          sendServer={sendServerDatagrid}
          noFilter
          rows={servicos}
          columns={colunas}
          rowCount={rowCount}
          disableAcoes
        />
      </DialogContent>
      <DialogActions className="m-3">
        <Button onClick={handleClose} color="padrao" variant="contained">
          Cancelar
        </Button>
        <Button color="success" variant="contained" onClick={confirmarCopia}>
          Confirmar
        </Button>
      </DialogActions>
      <Loading loading={loading} />
    </Dialog>
  );
}

export default CopiarServicoDialog;
